import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { branchValidationForm } from '../../utils/validationSchema';
import BranchForm from './BranchForm';
import Form from '../../layouts/Form';

const EditBranch = (props: any) => {
  const { handleEdit, isLoading, branchData } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
    watch
  } = useForm<any>({
    resolver: yupResolver(branchValidationForm),
    defaultValues: async () => {
      // let data: any = await props?.refetch()
      return await {
        ...branchData,
        primary_contact: branchData?.primary_contact ? branchData?.primary_contact.slice(4) : null,
        secondary_contact: branchData?.secondary_contact ? branchData?.secondary_contact.slice(4) : null,
        covered_city: branchData?.covered_city ? branchData?.covered_city?.map((item: any) => ({ label: item?.name, value: item?.id })):[]
      }
    }
  });
  console.log(errors)
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <BranchForm
        errors={errors}
        clearErrors={clearErrors}
        register={register}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
        branchData={branchData}
      />
    </Form>
  );
}

export default EditBranch
